module.exports = __webpack_public_path__ + "img/sidi-belabbes.04842df6.png";